module.exports = __webpack_public_path__ + "img/e90f2d4.jpg";